import { KeyValue } from './shared.types';

export function parseDroplinkParam(param?: string): KeyValue {
  const empty = { key: { value: '' }, value: { value: '' } };

  if (!param) {
    return empty;
  }

  try {
    return JSON.parse(param) as KeyValue;
  } catch (e) {
    console.error('Error parsing droplink param', e);
    return empty;
  }
}
